import React from 'react';
import './PeriodoHeader.css';

export interface PeriodoHeaderProps {
  periodo: string; // mm-yyyy
  onChange: (periodo: string) => void;
  title?: string;
}

export const getDefaultPeriodo = (): string => {
  const d = new Date();
  d.setMonth(d.getMonth() - 1);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${mm}-${yyyy}`;
};

const PeriodoHeader: React.FC<PeriodoHeaderProps> = ({ periodo, onChange, title }) => {
  const [mm, yyyy] = periodo.split('-');
  const inputValue = `${yyyy}-${mm}`; // YYYY-MM para input type="month"

  const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value; // YYYY-MM
    const [y, m] = val.split('-');
    if (!y || !m) return;
    onChange(`${m}-${y}`);
  };

  return (
    <div className="periodo-header">
      {title && <h2 className="periodo-title">{title}</h2>}
      <div className="periodo-controls">
        <label className="periodo-label">Período (mm/aaaa):</label>
        <input
          type="month"
          value={inputValue}
          onChange={handleMonthChange}
          className="periodo-input"
        />
        <span className="periodo-display">{mm}/{yyyy}</span>
      </div>
    </div>
  );
};

export default PeriodoHeader;